const validadores = {
    charParaValor: function (char) {
        const code = char.charCodeAt(0);
        if (code >= 48 && code <= 57) return code - 48;
        if (code >= 65 && code <= 90) return code - 48;
        if (code >= 97 && code <= 122) return code - 80;
        return -1;
    },

    validarCNPJ: function (cnpj) {
        if (cnpj == null || cnpj == undefined || cnpj == '') return false;

        cnpj = cnpj.replace(/[.\-\/]/g, '').toUpperCase();

        if (cnpj.length != 14) return false;

        //valida formato: primeiros 12 alfanuméricos, últimos 2 numéricos
        if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false;

        //elimina CNPJs com todos os caracteres iguais
        if (/^(.)\1{13}$/.test(cnpj)) return false;

        //pesos para cálculo dos dígitos verificadores
        var pesosD1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        var pesosD2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        //converte os 12 primeiros caracteres para valores numéricos (base-36)
        var valores = [];
        for (var i = 0; i < 12; i++) {
            var val = this.charParaValor(cnpj.charAt(i));
            if (val < 0) return false;
            valores.push(val);
        }

        //cálculo do primeiro dígito verificador
        var soma = 0;
        for (var i = 0; i < 12; i++) {
            soma += valores[i] * pesosD1[i];
        }
        var resto = soma % 11;
        var d1 = resto < 2 ? 0 : 11 - resto;

        if (d1 != parseInt(cnpj.charAt(12))) return false;

        //cálculo do segundo dígito verificador
        valores.push(d1);
        soma = 0;
        for (var i = 0; i < 13; i++) {
            soma += valores[i] * pesosD2[i];
        }
        resto = soma % 11;
        var d2 = resto < 2 ? 0 : 11 - resto;

        if (d2 != parseInt(cnpj.charAt(13))) return false;

        return true;
    }
}

export default validadores;



// WEBPACK FOOTER //
// ./src/helpers/validadores.js